import { createSelector } from 'reselect';
import get from 'lodash/get';
import { HOA_DETAILS } from '../../../Summaries/SummaryConstants';
import dictionarySelector from '../../../Summaries/SummaryDictionarySelector';
import {
  supportDataOrEmptyObjectSelector,
  previousSupportDataOrEmptyObjectSelector,
} from '../../../AdvWorkflow/AdvWorkflowSelector';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';

const previousYesOrNoSelector = createSelector(
  previousSupportDataOrEmptyObjectSelector,
  supportDataOrEmptyObject =>
    get(
      supportDataOrEmptyObject,
      `${HOME_PURCHASE_GOAL_GRAPH_NODE}.HasHomeownerAssociationFee`,
      null,
    ),
);

export const yesOrNoHomeownerAssociationFeeSelector = createSelector(
  supportDataOrEmptyObjectSelector,
  supportDataOrEmptyObject =>
    get(
      supportDataOrEmptyObject,
      `${HOME_PURCHASE_GOAL_GRAPH_NODE}.HasHomeownerAssociationFee`,
      null,
    ),
);

export const alreadyHadAssociationFeeSelector = createSelector(
  supportDataOrEmptyObjectSelector,
  supportDataOrEmptyObject =>
    get(
      supportDataOrEmptyObject,
      `${HOME_PURCHASE_GOAL_GRAPH_NODE}.AlreadyHadHomeownerAssociationFee`,
      null,
    ),
);

const nextIteratorsSelector = createSelector(
  yesOrNoHomeownerAssociationFeeSelector,
  previousYesOrNoSelector,
  dictionarySelector,
  (yesOrNoHomeownerAssociationFee, previousYesOrNo, dictionary) => {
    if (previousYesOrNo === yesOrNoHomeownerAssociationFee) {
      return [];
    }
    if (yesOrNoHomeownerAssociationFee === true) {
      return [HOA_DETAILS].map(dependencies => dictionary[dependencies].iterator);
    }
    return [];
  },
);

export default nextIteratorsSelector;
